import { render, staticRenderFns } from "./AcceleratorEnrollGroupItem.vue?vue&type=template&id=2b756a7a"
import script from "./AcceleratorEnrollGroupItem.vue?vue&type=script&lang=js"
export * from "./AcceleratorEnrollGroupItem.vue?vue&type=script&lang=js"
import style0 from "./AcceleratorEnrollGroupItem.vue?vue&type=style&index=0&id=2b756a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports